import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type AIConfidenceLevel = "weak" | "moderate" | "strong";

export type AISelectedCredit = {
  "subskill_id": string;
  "subskill_name": string;
  "subskill_score": number;
  "subskill_reason": string;
  "subskill_evidence": string;
  "subskill_confidence": AIConfidenceLevel;
};

export type AISelectedArea = {
  "skill_id": string;
  "skill_name": string;
  "skill_reason": string;
  "skill_confidence": AIConfidenceLevel;
  subskills: AISelectedCredit[]
};

// TODO: validate the exact strings of the confidence levels coming from the backend
export const aiScoreConfidenceValues: { [key in AIConfidenceLevel]: 1 | 2 | 3 } = {
  "weak": 1,
  "moderate": 2,
  "strong": 3,
};

export interface ArtifactAISkillSelectionsState {
  data: AISelectedArea[] | null;
};

const initialState: ArtifactAISkillSelectionsState = {
  data: null,
};

const artifactAISkillSelectionsSlice = createSlice({
  name: "artifactAISkillSelections",
  initialState,
  reducers: {
    setArtifactAISkillSelectionsRedux(state, action: PayloadAction<ArtifactAISkillSelectionsState["data"]>) {
      state.data = action.payload;
    },
    clearArtifactAISkillSelections(state) {
      state.data = null;
    },
  },
});

export const { setArtifactAISkillSelectionsRedux, clearArtifactAISkillSelections } = artifactAISkillSelectionsSlice.actions;

export default artifactAISkillSelectionsSlice.reducer;